import "../../../../src/content/glyt-uk-streaming/glyt-uk.scss";
import * as React from 'react';
export default {
  React
};